'use client';
import { lines } from '@s7/utils';

const POPOVER_ERRORS_CHILDREN = lines('Значение свойства children компонента Popover.Target должно быть элементом или компонентом, который принимает ref.', 'Фрагменты, строки, числа и иные примитивы не поддерживаются.');

export { POPOVER_ERRORS_CHILDREN };
//# sourceMappingURL=Popover.errors.js.map
